import React from "react";
import { FormLayout } from "playground/cms/Form";
import { ListLayout } from "playground/cms/List";
import Resources from "playground/cms/views/Resources";
import BuildingsForm from "./BuildingsForm";
import ListItem from "./ListItem";
import { Search } from "../../../cms/List/Filter";
import Filters from "./Filters";

//import PropTypes from 'prop-types';

export function Buildings(props) {
    const { type } = props;
    return (
        <Resources {...props} ListItem={ListItem}>
            <ListLayout>
                <ListLayout.Filter>
                    <Search type={type} name={"search"} />
                    <Filters {...props} />
                </ListLayout.Filter>
                <ListLayout.Header>
                    <ListLayout.Header.Icons prepend={true}>
                        <ListLayout.Header.Filter />
                    </ListLayout.Header.Icons>
                </ListLayout.Header>
            </ListLayout>
            <FormLayout>
                <FormLayout.Content replace={true}>
                    <FormLayout.Tab id={"building"} label={"Budynek"}>
                        <BuildingsForm {...props} />
                    </FormLayout.Tab>
                </FormLayout.Content>
            </FormLayout>
        </Resources>
    );
}

Buildings.propTypes = {};

Buildings.defaultProps = {};

export default Buildings;
